import {
    CREATE_YARN_PO_FAILURE_DK,
    CREATE_YARN_PO_REQUEST_DK,
    CREATE_YARN_PO_SUCCESS_DK,
    CREATE_USER_FORM_YARN_PO_DK,
    FETCH_SINGLE_YARN_PO_FAILURE_DK,
    FETCH_SINGLE_YARN_PO_REQUEST_DK,
    FETCH_SINGLE_YARN_PO_SUCCESS_DK,
    FETCH_YARN_PO_FAILURE_DK,
    FETCH_YARN_PO_REQUEST_DK,
    FETCH_YARN_PO_SUCCESS_DK,
    NAVIGATE_YARN_PO_DETAILS_DK,
    NAVIGATE_YARN_PO_DK,
    YARN_PO_USERFORM_RESET_DK,
    UPDATE_YARN_PO_FAILURE_DK,
    UPDATE_YARN_PO_REQUEST_DK,
    UPDATE_YARN_PO_SUCCESS_DK,
    DELETE_YARN_PO_REQUEST_DK,
    DELETE_YARN_PO_SUCCESS_DK,
    DELETE_YARN_PO_FAILURE_DK,
    FETCH_YARN_PO_SECTION_LIST_REQUEST_DK,
    FETCH_YARN_PO_SECTION_LIST_SUCCESS_DK,
    FETCH_YARN_PO_SECTION_LIST_FAILURE_DK,
    FETCH_YARN_PO_PROGRAM_LIST_REQUEST_DK,
    FETCH_YARN_PO_PROGRAM_LIST_SUCCESS_DK,
    FETCH_YARN_PO_PROGRAM_LIST_FAILURE_DK,
    FETCH_YARN_PO_SALES_ORDER_REQUEST_DK,
    FETCH_YARN_PO_SALES_ORDER_SUCCESS_DK,
    FETCH_YARN_PO_SALES_ORDER_FAILURE_DK,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST_DK,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS_DK,
    FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE_DK,
    FETCH_YARN_PO_WITHOUT_FILTER_REQUEST_DK,
    FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS_DK,
    FETCH_YARN_PO_WITHOUT_FILTER_FAILURE_DK,
    YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_YARN_PO_INVOICE_REQUEST_DK,
    FETCH_YARN_PO_INVOICE_SUCCESS_DK,
    FETCH_YARN_PO_INVOICE_FAILURE_DK,
    RESET_YARN_PO_INVOICE_DK,
    FETCH_YARN_PO_UNIT_LIST_REQUEST_DK,
    FETCH_YARN_PO_UNIT_LIST_SUCCESS_DK,
    FETCH_YARN_PO_UNIT_LIST_FAILURE_DK,
    FETCH_YARN_PO_SUPPLIER_LIST_REQUEST_DK,
    FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS_DK,
    FETCH_YARN_PO_SUPPLIER_LIST_FAILURE_DK,
    FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST_DK,
    FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS_DK,
    FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE_DK,
    SET_UNIT_NAME_YARN_PO_DK
} from './yarnPO.actionsType';

export const YARN_PO_DK = 'yarnPODK';

let initialState = {
    loading: false,
    yarnPO: [],
    sectionList: [],
    programList: [],
    deliveryListDK: [],
    yarnPOUnitList: [],
    yarnPoWithoutFilter: [],
    salesOrderList: [],
    yarnPoInvoice: [],
    supplierListDK: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    detailsId: '',
    activeKey: 1,
    isYarnPO: false,
    yarnPOSelectedValue: {},
    errorMessage: '',
    iperrorMessage: '',
    unitId: ''
};

export let yarnPODKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_PO_REQUEST_DK:
        case FETCH_YARN_PO_UNIT_LIST_REQUEST_DK:
        case FETCH_YARN_PO_INVOICE_REQUEST_DK:
        case CREATE_YARN_PO_REQUEST_DK:
        case FETCH_SINGLE_YARN_PO_REQUEST_DK:
        case UPDATE_YARN_PO_REQUEST_DK:
        case DELETE_YARN_PO_REQUEST_DK:
        case FETCH_YARN_PO_SECTION_LIST_REQUEST_DK:
        case FETCH_YARN_PO_SUPPLIER_LIST_REQUEST_DK:
        case FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST_DK:
        case FETCH_YARN_PO_PROGRAM_LIST_REQUEST_DK:
        case FETCH_YARN_PO_SALES_ORDER_REQUEST_DK:
        case FETCH_YARN_PO_WITHOUT_FILTER_REQUEST_DK:
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPO: updatePayload
            };
        case FETCH_YARN_PO_UNIT_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPOUnitList: updatePayload
            };
        case FETCH_YARN_PO_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPoInvoice: updatePayload
            };
        case FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnPoWithoutFilter: updatePayload
            };
        case FETCH_YARN_PO_SECTION_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                sectionList: updatePayload
            };
        case FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                supplierListDK: updatePayload
            };
        case FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                deliveryListDK: updatePayload
            };
        case CREATE_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                sectionList: [],
                detailsId: updatePayload
            };
        case FETCH_SINGLE_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case UPDATE_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_YARN_PO_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_YARN_PO_PROGRAM_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                programList: updatePayload
            };
        case FETCH_YARN_PO_SALES_ORDER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            };
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                styleNumberList: updatePayload
            };
        case FETCH_YARN_PO_FAILURE_DK:
        case FETCH_YARN_PO_UNIT_LIST_FAILURE_DK:
        case FETCH_YARN_PO_INVOICE_FAILURE_DK:
        case FETCH_SINGLE_YARN_PO_FAILURE_DK:
        case CREATE_YARN_PO_FAILURE_DK:
        case UPDATE_YARN_PO_FAILURE_DK:
        case DELETE_YARN_PO_FAILURE_DK:
        case FETCH_YARN_PO_SECTION_LIST_FAILURE_DK:
        case FETCH_YARN_PO_SUPPLIER_LIST_FAILURE_DK:
        case FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE_DK:
        case FETCH_YARN_PO_PROGRAM_LIST_FAILURE_DK:
        case FETCH_YARN_PO_SALES_ORDER_FAILURE_DK:
        case FETCH_YARN_PO_WITHOUT_FILTER_FAILURE_DK:
        case FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_PO_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case YARN_PO_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1,
                sectionList: []
            };
        case NAVIGATE_YARN_PO_DETAILS_DK:
            return {
                ...state,
                isYarnPO: true,
                yarnPOSelectedValue: updatePayload.yarnPOSelectedValue
            };
        case SET_UNIT_NAME_YARN_PO_DK:
            return {
                ...state,
                unitId: payload
            };
        case NAVIGATE_YARN_PO_DK:
            return {
                ...state,
                isYarnPO: false
            };
        case RESET_YARN_PO_INVOICE_DK:
            return {
                ...state,
                yarnPoInvoice: []
            };
        case YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
